module.exports = __webpack_public_path__ + "img/uz_get.9ff97b6.png";